const langInvestFundPerformancesListedAssetsLang = {
	graph_title: {
		tag: 'invest.fund_performances_listed_assets.graph_title',
		fr: 'Évolution des valeurs liquidatives',
		en: 'Net asset value trend',
	},
	export_data: {
		tag: 'invest.fund_performances_listed_assets.export_data',
		fr: 'Exporter les données',
		en: 'Export data',
	},
	funds: {
		tag: 'invest.fund_performances_listed_assets.funds',
		fr: 'Fonds',
		en: 'Funds',
	},
	vl_chart_legend: {
		tag: 'invest.fund_performances_listed_assets.vl_chart_legend',
		fr: 'Valeur liquidative (en €)',
		en: 'Net asset value (in €)',
	},
	vl: {
		tag: 'invest.fund_performances_listed_assets.vl',
		fr: 'vl',
		en: 'nav',
	},
	benchmark: {
		tag: 'invest.fund_performances_listed_assets.benchmark',
		fr: 'Benchmark',
		en: 'Benchmark',
	},
	performance: {
		tag: 'invest.fund_performances_listed_assets.performance',
		fr: 'Performance',
		en: 'Performance',
	},
	at_date: {
		tag: 'invest.fund_performances_listed_assets.at_date',
		fr: 'Au {{date}}',
		en: 'At {{date}}',
	},
	ONE_MONTH: {
		tag: 'invest.fund_performances_listed_assets.ONE_MONTH',
		fr: '1 mois',
		en: '1 month',
	},
	BEGIN_OF_YEAR: {
		tag: 'invest.fund_performances_listed_assets.BEGIN_OF_YEAR',
		fr: 'YTD',
		en: 'YTD',
	},
	ONE_YEAR: {
		tag: 'invest.fund_performances_listed_assets.ONE_YEAR',
		fr: '1 an',
		en: '1 year',
	},
	THREE_YEARS: {
		tag: 'invest.fund_performances_listed_assets.THREE_YEARS',
		fr: '3 ans',
		en: '3 years',
	},
	FIVE_YEARS: {
		tag: 'invest.fund_performances_listed_assets.FIVE_YEARS',
		fr: '5 ans',
		en: '5 years',
	},
	TEN_YEARS: {
		tag: 'invest.fund_performances_listed_assets.TEN_YEARS',
		fr: '10 ans',
		en: '10 years',
	},
	SINCE_INCEPTION: {
		tag: 'invest.fund_performances_listed_assets.SINCE_INCEPTION',
		fr: 'Depuis création',
		en: 'Since inception',
	},
	net_unit_assets: {
		tag: 'invest.fund_performances_listed_assets.net_unit_assets',
		fr: 'Actif net de la part au {{date}}',
		en: 'Net share class assets at {{date}}',
	},
	unit_net_asset_value: {
		tag: 'invest.fund_performances_listed_assets.unit_net_asset_value',
		fr: 'Valeur liquidative de la part au {{date}}',
		en: 'Unit net asset value at {{date}}',
	},
	ytd_percent_change: {
		tag: 'invest.fund_performances_listed_assets.ytd_percent_change',
		fr: 'Variation YTD en % au {{date}}',
		en: 'YTD % change at {{date}}',
	},
	cumulative_performance_percent: {
		tag: 'invest.fund_performances_listed_assets.cumulative_performance_percent',
		fr: 'Performances cumulées (%)',
		en: 'Cumulative performance (%)',
	},
	annualized_performance_percent: {
		tag: 'invest.fund_performances_listed_assets.annualized_performance_percent',
		fr: 'Performances annualisées (%)',
		en: 'Annualized performance (%)',
	},
	annual_performance_percent: {
		tag: 'invest.fund_performances_listed_assets.annual_performance_percent',
		fr: 'Performances annuelles (%)',
		en: 'Annual performance (%)',
	},
	performance_details: {
		tag: 'invest.fund_performances_listed_assets.performance_details',
		fr: 'Détail des performances',
		en: 'Performance details',
	},
	performance_details_tooltip: {
		tag: 'invest.fund_performances_listed_assets.performance_details_tooltip',
		fr: 'Les performances affichées sont nettes de frais de gestion',
		en: 'Performance figures are net of management fees',
	},
};

export default langInvestFundPerformancesListedAssetsLang;
